import {
  Card,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  Typography
} from "@mui/material";
import React, { useState } from "react";
import WarningIcon from "@mui/icons-material/Warning";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import mapMarkerBlue from "../../assets/images/marker_blue.png";
import { useDispatch } from "react-redux";
import {
  setProjectimages,
  setSelectedsite,
  setShowaddproject,
  setShowReport
} from "../../redux/actions/actions";
import Addsitename from "./Addsitename";
import { SAVE_SITES } from "../../constant/Apipath";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../request/Postrequest";
import Pages from "../../constant/ReportModel";
import { English } from "../../constant/EnglishFallback";

const SiteIssuesList = (props) => {
  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(false);
  const [siteDetailsToAddProduct, setSiteSiteDetailsToAddProduct] = useState(null);
  const dispatch = useDispatch();
  const { loginData, showMapmodal } = useSelector((state) => state?.main);
  const [showAddNameModal, setShowAddNameModal] = useState(false);
  const { multiLanguageData } = useSelector((state) => state?.main);
  const {
    BUTTON_ADD_PROJECT = English?.Map?.BUTTON_ADD_PROJECT,
    TEXT_REPORT = English?.Map?.TEXT_REPORT,
    TEXT_ADD_SITE_NAME = English?.Map?.TEXT_ADD_SITE_NAME
  } = multiLanguageData?.Map || {};
  const truncateText = (text, maxLength) => {
    if (text.length <= maxLength) {
      return text;
    }
    return text.substring(0, maxLength) + " ...";
  };

  const validValues = [
    "experience",
    "earn-rewards",
    "company-detail",
    "product-detail",
    "manufacture-detail"
  ];

  const onSiteClick = (site) => {
    if (props?.from === "modal") {
      if (validValues.includes(showMapmodal?.from)) {
        if (showMapmodal?.select === "project") {
          props.setShowsitedetail(true);
        } else if (showMapmodal?.select === "site") {
          props.setShowsitedetail(false);
        } else {
          props.setShowsitedetail(true);
        }
      } else {
        props.setShowsitedetail(false);
      }
    } else {
      props.setShowsitedetail(true);
    }
    dispatch(setSelectedsite(site)); // store the site
    props.setSitetypes(true);
    props?.setShowSiteCardModal(true);
  };

  const addToprofile = () => {
    dispatch(setProjectimages([]));
    dispatch(setSelectedsite(siteDetailsToAddProduct));
    dispatch(setShowaddproject(true));
    setMoreMenuAnchorEl(false);
  };

  const addReport = (item) => {
    const reportObj = {
      showReport: true,
      name: Pages?.site?.name,
      AppScreenId: Pages?.site?.id,
      recordId: item?.id || 0
    };
    dispatch(setShowReport(reportObj));
    setMoreMenuAnchorEl(false);
  };

  const SavesitewithName = async (name) => {
    try {
      const getObject = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: siteDetailsToAddProduct?.id,
            Name: name,
            Address: siteDetailsToAddProduct?.address,
            City: siteDetailsToAddProduct?.city,
            Province: siteDetailsToAddProduct?.province,
            PostalCode: siteDetailsToAddProduct?.postalCode,
            Country: siteDetailsToAddProduct?.country,
            Latitude: siteDetailsToAddProduct?.latitude ?? 0,
            Longitude: siteDetailsToAddProduct?.longitude ?? 0,
            StartDate: "",
            EndDate: "",
            Active: siteDetailsToAddProduct?.active,
            RecordStatusId: 1,
            ContractorId: 0,
            JobNo: "",
            ConstructionStatusId: 0,
            ModifiedBy: loginData?.userInformation?.UserId
          }
        ]
      };
      const getResponse = await Postrequestcall(SAVE_SITES, getObject, loginData?.accessToken);
      if (getResponse.status === 201) {
        setShowAddNameModal(false);
        await props.onFilterClick("Unnamed");
      }
    } catch (error) {
      console.log("SavesitewithName-> Error While Saving Site: ", error);
    } finally {
    }
  };

  return (
    <>
      <List sx={{ p: 0.5 }}>
        <Stack spacing={0.5}>
          {props?.siteList?.map((item, index) => {
            return (
              <Card key={index.toString()} className="pagelist-content" sx={{ marginTop: "0px" }}>
                <ListItem
                  key={index.toString()}
                  sx={{ m: 0 }}
                  secondaryAction={
                    <>
                      {item?.isMySites ? (
                        <IconButton disabled>
                          <img src={mapMarkerBlue} alt="Marker blue" height={"25px"} />
                        </IconButton>
                      ) : item?.name === "" ? (
                        <IconButton disabled>
                          <WarningIcon style={{ color: "#FFBC0A" }} />
                        </IconButton>
                      ) : (
                        <></>
                      )}
                      {validValues.includes(showMapmodal?.from) ? (
                        <></>
                      ) : (
                        <>
                          {!props?.showChooseOption ? (
                            <>
                              <IconButton
                                onClick={(event) => {
                                  event.stopPropagation();
                                  event.preventDefault();
                                  setSiteSiteDetailsToAddProduct(item);
                                  setMoreMenuAnchorEl(event.currentTarget);
                                }}>
                                <MoreHorizIcon fontSize="small" />
                              </IconButton>

                              {Boolean(moreMenuAnchorEl) &&
                                siteDetailsToAddProduct?.id === item?.id && (
                                  <Menu
                                    anchorOrigin={{
                                      vertical: "top",
                                      horizontal: "right"
                                    }}
                                    transformOrigin={{
                                      vertical: "top",
                                      horizontal: "right"
                                    }}
                                    anchorEl={moreMenuAnchorEl}
                                    open={Boolean(moreMenuAnchorEl)}
                                    onClose={(event) => {
                                      setMoreMenuAnchorEl(false);
                                    }}>
                                    {siteDetailsToAddProduct?.name === "" ? (
                                      <MenuItem
                                        onClick={() => {
                                          setMoreMenuAnchorEl(false);
                                          setShowAddNameModal(true);
                                        }}
                                        style={{ color: "#083db8" }}>
                                        {TEXT_ADD_SITE_NAME}
                                      </MenuItem>
                                    ) : null}
                                    <MenuItem
                                      onClick={() => addToprofile()}
                                      style={{ color: "#083db8" }}>
                                      {BUTTON_ADD_PROJECT}
                                    </MenuItem>
                                    <MenuItem
                                      onClick={() => addReport(item)}
                                      style={{ color: "red" }}>
                                      {TEXT_REPORT}
                                    </MenuItem>
                                  </Menu>
                                )}
                            </>
                          ) : null}
                        </>
                      )}
                    </>
                  }
                  disablePadding>
                  <ListItemButton sx={{ p: 0, pl: 1.5 }} onClick={() => onSiteClick(item)}>
                    <ListItemText
                      primary={
                        <Typography
                          variant="body1"
                          maxWidth={"260px"}
                          noWrap
                          sx={{
                            color: item?.name?.trim() !== "" ? "black" : "GrayText"
                          }}>
                          {item?.name || "Unnamed Site"}{" "}
                        </Typography>
                      }
                      secondary={truncateText(item?.address, 45) || null}
                    />
                  </ListItemButton>
                </ListItem>
              </Card>
            );
          })}
        </Stack>
      </List>
      {showAddNameModal && (
        <Addsitename
          showAddNameModal={showAddNameModal}
          SavesitewithName={SavesitewithName}
          handleClose={() => setShowAddNameModal(false)}
        />
      )}
    </>
  );
};

export default SiteIssuesList;
